import {
  CircularProgress,
  IconButton,
  Tooltip,
  Typography
} from '@material-ui/core'
import AddIcon from '@material-ui/icons/Add'
import React from 'react'

export const CriarIntegracaoEagle = ({ 
  hidden,
  creating,
  initialLoading,
  handleCreate,
  tooltipText
}) => {
  if (hidden) return null
  if (initialLoading) {
    return <CircularProgress size={24} />
  }

  const tooltip = creating ? 'Fazendo integração com a Eagle, aguarde...' : tooltipText 

  return (
    <IconButton
      disabled={creating}
      size="small"
      onClick={handleCreate}
    >
      <Tooltip
        title={
          <Typography variant="caption">
              {creating
                ? 'Fazendo integração com a Eagle, aguarde...'
                : tooltip}
          </Typography>
        }
      >
        {creating ? <CircularProgress size={12} /> : <AddIcon />}
      </Tooltip>
    </IconButton>
  )
}